// extracted by mini-css-extract-plugin
module.exports = {"client-page-title":"style-module__client-page-title___3oo9P","client-home-content":"style-module__client-home-content___11RF0","not-exist":"style-module__not-exist___1CpMC"};